import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { storeOperations } from './state';
import { bindActionCreators } from 'redux'
import ModuleContainer from '../../components/ModuleContainer';
import { Form } from 'react-bootstrap';
import DraggableTable from '../../components/DraggableTable';
import { FaPlus, FaEye, FaTrashAlt, FaEdit } from 'react-icons/fa';
import {
  MODE_EDIT, MODE_VIEW, SUCCESS, NOTIF_SUCCESS, NOTIF_ERROR, NOTIF_WARNING, DEFAULT_STORE_ID, STORES, SECONDARY, SEARCH_LENGTH, SUCCESS_BUTTON, ADD_STORE,
  LINK, BLACK, BLUE, RED, DELETE_STORE, NO, YES, DANGER
} from '../../../utils/constants';
import { CANNOT_DELETE_SHSAA, DISABLED_DRAGGING, REARRANGE_DRAGGING, DELETE_MESSAGE } from '../../../utils/messages';
import { ADD_STORE_ROUTE, VIEW_STORE_ROUTE } from './routes';
import ViewHeader from '../../components/ViewHeader';
import ConfirmationModal from '../../components/ConfirmationModal';
import { isNullOrUndefined } from '../../../../node_modules/util';
import { SideNotification } from '../../../utils/common';
import debounce from 'lodash.debounce';

class Stores extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sortedList: props.storeList,
      search: '',
      includeInactive: false,
      sortSponsorship: false,
      showDeleteModal: false,
      modalId: null
    };
    this.retrieveList = debounce(this.retrieveList.bind(this), 500);
    this.deleteRow = debounce(this.deleteRow.bind(this), 500);
  }

  componentDidMount() {
    this.retrieveList();
  }

  retrieveList = () => {
    this.props.getStoreList(this.state.search, this.state.includeInactive)
      .then(result => {
        if (undefined !== result) {
          if (SUCCESS === result.status) {
            this.setState({ sortedList: result.data.storeList });
          }
        }
      }).catch(() => { })
  }

  updateDraggedList = (sortedList) => {
    let oldList = Object.assign([], this.state.sortedList.sort((a, b) => {
      a.listOrder = 1;
      b.listOrder = 1;
      return null;
    }));
    this.setState({ sortedList }, () => {
      this.props.sortDraggable(sortedList)
        .then(result => {
          if (undefined === result) {
            //Return back to old list if error in API
            this.setState({ sortedList: oldList })
          }
        });
    })
  }

  handleDragCheckbox = (event) => {
    this.setState({ [event.target.name]: !this.state[event.target.name] }, () => {
      let oldList = Object.assign([], this.state.sortedList);
      let newStoreList = Object.assign([], this.state.sortedList.sort((a, b) => {
        a.listOrder = 0;
        b.listOrder = 0;
        return b.storeSponsorship - a.storeSponsorship
      }));
      this.setState({ sortedList: newStoreList }, () => {
        this.props.resetSortDraggable()
          .then(result => {
            if (undefined === result) {
              //Return back to old list if error in API
              this.setState({ sortedList: oldList })
            }
          });
      })
    })
  }

  isSortedBySponsorship = () => {
    return SEARCH_LENGTH === this.state.sortedList.filter(item => item.listOrder > SEARCH_LENGTH).length
  }

  handleSearchChange = (event) => {
    this.setState({ search: event.target.value }, () => this.retrieveList());
  }

  handleInactiveCheckboxChange = () => {
    this.setState({ includeInactive: !this.state.includeInactive }, () => this.retrieveList());
  }

  viewStore = (data, type) => {
    let params = {};
    if (MODE_EDIT === type || MODE_VIEW === type) {
      params.data = data;
      params.type = type;

      this.props.history.push({
        pathname: VIEW_STORE_ROUTE + `/${data.storeId}`,
        state: params
      })
    } else {
      this.props.history.push(ADD_STORE_ROUTE);
    }
  }

  toggleDelete = (row) => {
    if (!isNullOrUndefined(row) && DEFAULT_STORE_ID === row.storeId) {
      SideNotification(NOTIF_WARNING, CANNOT_DELETE_SHSAA);
    } else {
      this.setState(prevState => ({ showDeleteModal: !prevState.showDeleteModal, modalId: isNullOrUndefined(row) ? null : row.storeId }))
    }
  }

  deleteRow = () => {
    this.props.deleteStore(this.state.modalId)
      .then((result) => {
        if (SUCCESS === result.status) {
          SideNotification(NOTIF_SUCCESS, result.message);
          this.retrieveList();
        } else {
          SideNotification(NOTIF_ERROR, result.message);
        }
        this.toggleDelete();
      });
  }

  render() {
    return (
      <ModuleContainer>
        <ViewHeader
          withSearch={true}
          title={STORES}
          onSearchChange={this.handleSearchChange}
          sideSearch={
            <div className="list-checkbox">
              <Form.Check name="includeInactive" type={"checkbox"} id="active-check" label={`Include Inactive`} onChange={this.handleInactiveCheckboxChange} />
            </div>
          }
          rightButtons={[
            { variant: SUCCESS_BUTTON, label: ADD_STORE, icon: FaPlus, onClick: this.viewStore }
          ]}
        />

        <Form.Check name="sortSponsorship" checked={this.isSortedBySponsorship()} type={"checkbox"} id="sponsorship-check" label={`Sort by sponsorship`} onChange={this.handleDragCheckbox} /><br />

        <DraggableTable
          listKey="storeList"
          draggableList={this.state.sortedList}
          customMessage={SEARCH_LENGTH < this.state.search.length ? DISABLED_DRAGGING : REARRANGE_DRAGGING}
          tableColumns={this.props.draggableTable.tableColumns}
          tableHeaders={this.props.draggableTable.tableHeaders}
          updateDraggedList={this.updateDraggedList}
          isDragDisabled={SEARCH_LENGTH < this.state.search.length}
          rowButtons={[
            { variant: LINK, icon: FaEye, color: BLACK, onClick: this.viewStore, type: MODE_VIEW },
            { variant: LINK, icon: FaEdit, color: BLUE, onClick: this.viewStore, type: MODE_EDIT },
            { variant: LINK, icon: FaTrashAlt, color: RED, onClick: this.toggleDelete }
          ]}
        />

        <ConfirmationModal
          show={this.state.showDeleteModal}
          toggleModal={this.toggleDelete}
          title={DELETE_STORE}
          message={DELETE_MESSAGE}
          modalButtons={[
            { label: NO, onClick: this.toggleDelete, variant: SECONDARY },
            { label: YES, onClick: this.deleteRow, variant: DANGER }
          ]}
        />
      </ModuleContainer>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    storeList: state.stores.storeList,
    draggableTable: state.stores.draggableTable
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getStoreList: storeOperations.getStoreList,
    deleteStore: storeOperations.deleteStore,
    sortDraggable: storeOperations.sortDraggable,
    resetSortDraggable: storeOperations.resetSortDraggable
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(Stores);